import axiosInstance from "./axiosInstance";

import { API_V2 } from "@Models/GWDomain";

export const accountBaseUrl = `${API_V2}/account`;

/**
 * @deprecated No usar directamente. El token ahora se obtiene dinamicamente via interceptor.
 * Mantenido solo por compatibilidad con codigo legacy que pueda importarlo.
 */
const tokenLocal = localStorage.getItem("access_token");

/**
 * @deprecated No usar directamente. El header de autorizacion ahora se agrega
 * automaticamente via interceptor en cada request.
 * Usar axiosInstance en lugar de axios con este config.
 */
export const config = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${tokenLocal}`,
  },
};

// Exportar la instancia de axios configurada para uso directo
export { axiosInstance };
